import React, {Component} from 'react';
import {Elements, StripeProvider, CardElement, injectStripe} from 'react-stripe-elements';
import {Button, Text} from 'ui';
import useKey from 'config/useKey';
import './index.css';


class CheckoutForm extends Component {
  state = {
    verifying: false,
  }
  
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  async submit(ev) {
    if(this.state.verifying) {
      return;
    }
    if(this.props.submitting) {
      return;
    }
    this.setState({verifying:true});
    try {
      let {token} = await this.props.stripe.createToken({name:"Name"});
      if(token && token.id) {
        this.props.onSubmit(token.id);
      }
    }
    catch(error) {
      console.log('checkoutform', error);
      return;
    }
    this.setState({verifying:false});
  }

  render() {
    return (
      <div className="checkout">
        <Text bold block small style={{marginBottom:4}}>
          Payment Details
        </Text>
        <CardElement 
          style={{
            base: {
              fontSize: '20px',
              color: '#243746',
              fontFamily: 'MontserratLight, sans-serif',
              '::placeholder': {
                color: '#aab7c4',
              },
              lineHeight: '32px',
              backgroundColor: '#ffffff',
              // boxShadow: this.props.outline ? 'none' : '0 1px 2px rgba(0,0,0,0.3)',
              // border: this.props.outline ? '1px solid #aaa' : 0,
              border: '1px solid #aaa',
            },
            invalid: {
              color: '#ff0000',
            },
          }}
        />
        <div className="checkout-nav" style={{display:'flex', alignItems:'center'}}>
          <Button 
            onClick={this.submit}>
            {
              this.props.submitting ? "Submitting..." : 
              this.state.verifying ? "Verifying..." : 
              "Submit"
            }
          </Button>
          {this.props.onCancel && 
            <Button tertiary label="Cancel" onClick={this.props.onCancel}/>
          }
        </div>
        
      </div>
    );
  }
}

const ConnectedCheckoutForm = injectStripe(CheckoutForm);



export default function(props) {
  const key = useKey("stripe");
  
  if(!key) {
    return null;
  }
  
  // prod
  
  return (
    <StripeProvider apiKey={key}>
      <Elements>
        <ConnectedCheckoutForm {...props}/>
      </Elements>
    </StripeProvider>
  );
}
